<template>
  <a-drawer
    :title="addNoticeState.title"
    v-model:open="state.showAddNotice"
    class="small"
    width="70%"
  >
    <a-form
      class="small pb-30px"
      :model="addNoticeState.formData"
      :rules="addNoticeState.rules"
      layout="vertical"
      ref="formRef"
    >
      <a-row :gutter="[20, 0]">
        <a-col :span="24">
          <a-form-item label="类型" name="type">
            <a-radio-group v-model:value="addNoticeState.formData.type">
              <a-radio
                :value="item.value"
                v-for="item in addNoticeState.typeOptions"
                :key="item.value"
                >{{ item.label }}</a-radio
              >
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="有效时间" name="effectiveType">
            <a-radio-group
              v-model:value="addNoticeState.formData.effectiveType"
            >
              <a-radio
                :value="item.value"
                v-for="item in addNoticeState.timeOptions"
                :key="item.value"
                >{{ item.label }}</a-radio
              >
            </a-radio-group>
            <a-range-picker
              v-if="addNoticeState.formData.effectiveType === 1"
              allowClear
              class="w-full !w-3/5"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              v-model:value="addNoticeState.formData.effectives"
              :placeholder="['开始日期', '结束日期']"
            /> </a-form-item
        ></a-col>
        <a-col :span="12">
          <a-form-item label="是否强制弹窗" name="isMandatory">
            <a-radio-group v-model:value="addNoticeState.formData.isMandatory">
              <a-radio
                :value="item.value"
                v-for="item in addNoticeState.boolOptions"
                :key="item.value"
                >{{ item.label }}</a-radio
              >
            </a-radio-group>
          </a-form-item></a-col
        >
        <a-col :span="12">
          <a-form-item
            label="限制弹窗时长（秒）"
            :name="addNoticeState.formData.isMandatory ? 'popupTime' : ''"
          >
            <a-input-number
              class="w-full"
              v-model:value="addNoticeState.formData.popupTime"
              :min="0"
              :max="120"
              :precision="0"
              :disabled="!addNoticeState.formData.isMandatory"
            /> </a-form-item
        ></a-col>
        <a-col :span="12">
          <a-form-item label="是否允许下载" name="isDownloadAllowed">
            <a-radio-group
              v-model:value="addNoticeState.formData.isDownloadAllowed"
            >
              <a-radio
                :value="item.value"
                v-for="item in addNoticeState.boolOptions"
                :key="item.value"
                >{{ item.label }}</a-radio
              >
            </a-radio-group>
          </a-form-item></a-col
        >

        <a-col
          :span="24"
          v-if="
            addNoticeState.permissions?.internalStaff ||
              addNoticeState.permissions?.externalSupplier
          "
        >
          <a-form-item label="发布范围" name="" class="isrequired">
            <a-checkbox-group
              class="!w-full"
              v-model:value="addNoticeState.formData.releaseScopeArr"
            >
              <div
                class="w-full flex items-center"
                v-if="addNoticeState.permissions?.internalStaff"
              >
                <a-checkbox value="1" class="flex-shrink-0"
                  >内部员工
                </a-checkbox>
                <a-tree-select
                  style="width: 200px"
                  :disabled="
                    !addNoticeState.formData.releaseScopeArr?.includes('1')
                  "
                  class="!w-200px ml-10px"
                  v-model:value="
                    addNoticeState.formData.internalDepartmentScopeArr
                  "
                  :tree-data="addNoticeState.staffList"
                  show-search
                  placeholder="请选择"
                  allow-clear
                  tree-checkable
                  show-checked-strategy="SHOW_ALL"
                  :max-tag-count="1"
                  @click.stop
                  @mousedown.stop
                  @change="
                    val => {
                      handleChangeSelect(val, '1')
                    }
                  "
                  :dropdownMatchSelectWidth="false"
                />
                <span class="ml-20px">
                  以下人员除外
                  <cps-select
                    :disabled="
                      !addNoticeState.formData.internalDepartmentScopeArr
                        ?.length
                    "
                    class="!w-200px ml-10px"
                    v-model:value="addNoticeState.formData.excludeStaffArr"
                    url="/config/list-staff"
                    label="fullName"
                    labelValue="id"
                    mode="multiple"
                    immediate
                    respField="data.list"
                    :maxTagCount="1"
                  ></cps-select>
                </span>
              </div>
              <div
                class="w-full flex items-center mt-10px"
                v-if="addNoticeState.permissions?.externalSupplier"
              >
                <a-checkbox value="2" class="flex-shrink-0"
                  >外部供应商
                </a-checkbox>
                <a-tree-select
                  :disabled="!addNoticeState.supplierTree.length"
                  v-model:value="
                    addNoticeState.formData.supplierClassificationArr
                  "
                  class="!w-200px ml-10px"
                  :tree-data="addNoticeState.supplierTree"
                  show-search
                  placeholder="请选择供应商分类"
                  allow-clear
                  tree-checkable
                  show-checked-strategy="SHOW_CHILD"
                  :max-tag-count="1"
                  @click.stop
                  @mousedown.stop
                  @change="
                    val => {
                      handleChangeSelect(val, '2')
                    }
                  "
                  :dropdownMatchSelectWidth="false"
                />
                <a-select
                  :disabled="!addNoticeState.cooperationModeList?.length"
                  class="!w-200px ml-10px"
                  v-model:value="addNoticeState.formData.cooperationModeArr"
                  :options="addNoticeState.cooperationModeList"
                  mode="multiple"
                  :maxTagCount="1"
                  placeholder="请选择供应商合作模式"
                ></a-select>
                <span class="ml-20px">
                  以下供应商除外
                  <cps-select
                    :disabled="
                      !addNoticeState.formData.releaseScopeArr?.includes('2')
                    "
                    class="!w-200px ml-10px"
                    v-model:value="addNoticeState.formData.excludeSupplierArr"
                    url="doc/list-supplier"
                    label="supplierName"
                    labelValue="id"
                    mode="multiple"
                    immediate
                    :maxTagCount="1"
                  ></cps-select>
                </span>
              </div>
            </a-checkbox-group> </a-form-item
        ></a-col>
        <a-col :span="12">
          <a-form-item label="分类">
            <a-input
              v-model:value="addNoticeState.formData.category"
              placeholder="请输入"
              class="w-full"
              :maxLength="100"
            /> </a-form-item
        ></a-col>
        <a-col :span="12">
          <a-form-item label="归属部门" name="belongDepartment">
            <cps-select
              v-model:value="addNoticeState.formData.belongDepartment"
              url="/dict/list-dict"
              label="dictDesc"
              labelValue="dictCode"
              immediate
              :params="{
                dictType: 8502
              }"
              show-search
              valueType="number"
            ></cps-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="商品大类">
            <cps-select
              v-model:value="addNoticeState.formData.goodsMajorCategory"
              url="/dict/list-dict"
              label="dictDesc"
              labelValue="dictCode"
              immediate
              :params="{
                dictType: 8418
              }"
              show-search
              valueType="number"
            ></cps-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="关键词">
            <a-input
              v-model:value="addNoticeState.formData.keyword"
              placeholder="请输入"
              class="w-full"
              :maxLength="100"
            /> </a-form-item
        ></a-col>
        <a-col :span="24">
          <a-form-item label="标题" name="title">
            <a-input
              v-model:value="addNoticeState.formData.title"
              placeholder="请输入"
              class="w-full"
              :maxLength="100"
            /> </a-form-item
        ></a-col>
        <a-col :span="24">
          <a-form-item label="具体内容" name="content">
            <wangEditor
              ref="wangeditorRef"
              v-model:value="addNoticeState.formData.content"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="视频上传">
            <oss-upload
              class="h-100px"
              v-model:files="addNoticeState.formData.videoFileList"
              showErrorFile
              :isDragger="false"
              :canPaused="true"
              accept=".mp4,.mov"
              :limitNum="10"
            >
              <upload-outlined></upload-outlined>
              <span class="text-12px ml-10px">点击上传</span>
            </oss-upload>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="文件上传（仅支持上传PDF）">
            <oss-upload
              class="h-100px"
              v-model:files="addNoticeState.formData.fileList"
              showErrorFile
              :isDragger="false"
              :canPaused="true"
              accept=".pdf"
              :limitNum="10"
              :size="30"
            >
              <upload-outlined></upload-outlined>
              <span class="text-12px ml-10px">点击上传</span>
            </oss-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="drawer-footer">
      <a-button size="small" class="mr-8px" @click="state.showAddNotice = false"
        >取消</a-button
      >
      <a-button size="small" class="mr-8px" @click="publish(0)">保存</a-button>
      <a-popconfirm
        title="是否确定发布？"
        ok-text="是"
        cancel-text="否"
        @confirm="publish(1)"
        ><a-button size="small" type="primary">立即发布</a-button>
      </a-popconfirm>
    </div>
  </a-drawer>
</template>
<script setup>
import { inject, defineProps, ref } from 'vue'
import { useAddNotice } from '../share'
import wangEditor from './wangEditor.vue'
import { UploadOutlined } from '@ant-design/icons-vue'
const noticePublishModule = inject('noticePublishModule')
const props = defineProps({
  id: {
    type: [String, Number],
    default: null
  }
})
const { state } = noticePublishModule
const {
  addNoticeState,
  publish,
  formRef,
  wangeditorRef,
  changeReleaseScope,
  handleChangeSelect
} = useAddNotice(props, state)
</script>
<style lang="scss" scoped>
:deep(.portal-ant-checkbox-wrapper + .portal-ant-checkbox-wrapper) {
  margin-left: 0;
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
:deep(.isrequired .portal-ant-form-item-label::before) {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  line-height: 1;
  content: '*';
}
</style>
